export default function dateDiff (date) {
  const dateY = date.getFullYear()
  const dateM = date.getMonth()
  const dateD = date.getDate()
  const newDate = new Date(dateY, dateM, dateD)

  const now = new Date()
  const nowY = now.getFullYear()
  const nowM = now.getMonth()
  const nowD = now.getDate()
  const nowDate = new Date(nowY, nowM, nowD)

  const day = parseInt(Math.abs(nowDate - newDate) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
  if (day === 0) {
    return '今天'
  }
  return day + '天前'
}

Date.prototype.format = function(fmt) { //author: meizz
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}



// WEBPACK FOOTER //
// ./src/utils/dateDiff.js